module.exports = __webpack_public_path__ + "static/media/sportRoomIcon.59effa60.svg";